import type { ZoneOfInterestPayload } from './events';
import type { BuildZoneOfInterestParams } from './type';
import { page as pageState } from '$app/state';
import { buildBaseItineraryTrackingData } from './tracking';

export function buildZoiSelectionTrackingData({
	context,
	zoiCount,
	zoiPosition,
	zoi,
	isArrivalZoi,
	tripOptions,
}: BuildZoneOfInterestParams): ZoneOfInterestPayload {
	const isElectricVehicle = tripOptions.car?.isEv;
	return {
		action: 'selection',
		...buildBaseItineraryTrackingData(pageState),
		context,
		position: zoiPosition.toString(),
		zoi_count: zoiCount.toString(),
		zoi_id: zoi?.zoiId?.toString(),
		zoi_containsEvStation: zoi?.containsEvStation?.toString(),
		zoi_radius: zoi?.radius?.toString(),
		zoi_position: isArrivalZoi ? 'at_arrival' : 'on_road',
		zoi_category: isArrivalZoi ? 'accommodation' : 'green_guide',
		zoi_description: zoi?.description,
		zoi_title: zoi?.name,
		range_rating_alert: isElectricVehicle ? tripOptions.rechargeTreshold?.toString() : undefined,
		price_kwh: isElectricVehicle ? tripOptions.energyPrice?.toString() : undefined,
	};
}
